import { push, getLocation } from 'connected-react-router';
import qs from 'qs';

export function closeCandidateProfile() {
  return (dispatch, getState) => {
    const location = getLocation(getState());
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    delete queryParams.applicationId;

    dispatch(
      push({
        pathname: location.pathname,
        search: qs.stringify(queryParams, { addQueryPrefix: true }),
      }),
    );
  };
}
